/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 07/02/2018.
*
* end-game Vue Component
*/
<template>
  <div class="end-game-mask">
    <div class="end-game-container">
      <div class="end-game-inner">
        <img
          src="~/../assets/trophy.svg"
          alt="Felicidades"
          class="trophy">
        <h2>¡JUEGO TERMINADO!</h2>
        <p class="score-msg">Tus registros son los siguientes</p>
        <div class="scores-container">
          <table>
            <thead>
              <tr>
                <!-- <th>RONDA</th> -->
                <th>NIVEL</th>
                <th>TIEMPO</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <!-- <td>{{ round[index] }}</td> -->
                <td>{{ attempts }}</td>
                <td>{{ time }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="thanks-msg">¡GRACIAS POR PARTICIPAR! </p>
        <button
          class="btn btn-primary btn-block"
          @click="closeGame">SALIR</button>
      </div>
    </div>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
export default {
  props: {
    games: {
      type: Array,
      required: true
    },
    attempts: {
      type: Number,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    currentRound: {
      default: 1,
      type: Number,
      required: true
    }
  },
  data () {
    return {
      round: {
        1: 'Primera',
        2: 'Segunda',
        3: 'Tercera'
      }
    }
  },
  methods: {
    closeGame () {
      this.$router.push('WelcomeView')
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
.end-game-mask {
  background-color: transparent;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}

.end-game-container {
  width: 100%;
  max-width: 100%;
  height: 1024px;
  max-height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scores-container {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebebeb;
  .score {
    .score-data {
      color: #00adda;
    }
    .score-label {
      color: #999999;
    }
  }
}

.btn-go-out {
  background-color: #00adda;
  color: #ffffff;
}

.end-game-logo {
  width: 200px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.end-game-inner {
  box-sizing: border-box;
  text-align: center;
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  max-width: 360px;
  padding: 30px;
  .trophy {
    position: relative;
    top: -15px;
    width: 125px;
    margin-top: -45px;
  }
  h2 {
    color: #666666;
    margin-top: 0;
    margin-bottom: 10px;
  }
  .score-msg {
    margin: 10px 0;
    color: #999999;
  }
  .thanks-msg {
    color: #999999;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/simon-game/components/end-game.vue